<template>
  <base-header
    :settings="settings"
    :is-addition-disabled="isAdditionDisabled"
    :is-deletion-disabled="isDeletionDisabled"
    :disabled="disabled"
    v-on="$listeners"
  >
    <img class="mx-2" :src="require('@/assets/icons/mar.ia-cor.svg')" alt="maria" />
    <span>Mar.ia escolhe o melhor dia da semana para disparar as mensagens</span>
  </base-header>
</template>

<script>
import BaseHeader from './BaseHeader.vue'

export default {
  name: 'MariaHeaderDispatchPanel',
  components: { BaseHeader },
  props: {
    settings: {
      type: Object,
      required: true,
    },
    isAdditionDisabled: {
      type: Boolean,
      default: false,
    },
    isDeletionDisabled: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
